import { Link } from "@tanstack/react-router";
import { Button } from "@wags/ui/button.tsx";
import { NotFoundState } from "@/components/shared/NotFound";

export function DogNotFound({ onBack }: { onBack: () => void }) {
    return (
        <div className="min-h-dvh w-full bg-true-white">
            <NotFoundState
                className="min-h-dvh"
                title="This pup isn't here"
                description="The listing may have been removed, or the link may be outdated."
                actions={
                    <>
                        <Button
                            type="button"
                            variant="outline"
                            size="lg"
                            onClick={onBack}
                        >
                            Go back
                        </Button>
                        <Button size="lg" asChild>
                            <Link to="/find">Browse dogs</Link>
                        </Button>
                    </>
                }
            />
        </div>
    );
}
